<script setup>
defineProps(['model'])
</script>

<template>
  <div class="block-spacing w-full container-text eight-col-max mx-auto my-10">
    <div
      v-if="model.title?.value"
      class="prose w-full eight-col-max"
    >
      <div class="h2 text-pretty">
        {{ model.title?.value }}
      </div>
    </div>
    <div class="lg:flex lg:gap-14 lg:items-start">
      <div class="lg:w-1/2">
        <div
          v-if="model.body?.value"
          class="icon-list__body prose"
          v-html="model.body?.value"
        />
        <UButton
          :to="useCmsUrl(model.contactLink?.value?.href)"
          :locale="false"
          variant="solid"
          class="my-5"
          size="lg"
        >
          {{ model.contactLink?.value?.text }}
        </UButton>
      </div>
      <div class="lg:w-1/2 flex flex-col gap-10">
        <ContactUsIconBlock
          v-for="(iconItem, index) in model.contactUsIcons?.expandedValue"
          :key="index"
          :item="iconItem"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.icon-list__body {
  > * {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
